import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { MakeProvider } from '../../../../helpers/base-control-value-accessor';
import { FormValue } from '../../../entities/form-value.entity';
import { ShFormNumberComplexBaseComponent } from '../base-complex/form-number-complex-base.component';
import { AsyncPipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'sh-form-number-base',
    templateUrl: '../base-complex/form-number-complex-base.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(ShFormNumberBaseComponent)],
    standalone: true,
    imports: [ReactiveFormsModule, AsyncPipe]
})
export class ShFormNumberBaseComponent extends ShFormNumberComplexBaseComponent {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    propagateChange(fv: FormValue<number | null>): void {
        super.propagateSimpleChange(FormValue.unwrap(fv));
    }

    writeValue(obj: any): void {
        super.writeValue(FormValue.wrap(obj));
    }
}
